import { CarouselFeature } from "./feature-base.js";
const Events = {
  CHANGE: "SKAPA_CAROUSEL_WRITING_DIRECTION_CHANGE"
};
class RTLHandlerFeature extends CarouselFeature {
  constructor() {
    super(...arguments);
    this.isRTL = false;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "skapa-rtl") {
      this.isRTL = newValue !== null;
      this.dispatchEvent(new WritingDirectionChangeEvent(this.isRTL));
    }
  }
}
RTLHandlerFeature.observedAttributes = ["skapa-rtl"];
class WritingDirectionChangeEvent extends Event {
  constructor(rtl) {
    super(Events.CHANGE, { bubbles: false });
    this.rtl = rtl;
  }
}
export {
  Events,
  RTLHandlerFeature,
  WritingDirectionChangeEvent
};
